import React from 'react'
import styled from 'styled-components'
import { mobile } from '../responsive';

const Container = styled.div`
    ${mobile({ paddingTop: "25px", height: "10px" })}
`;

const Text = styled.div`
    height: 30px;
    background-color: #0039a6;
    color: white;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
`


const Announcement = () => {
  return (
    <Container>
      <Text>
        HOURS: &nbsp; MON-SAT: 8 AM - 5 PM, &nbsp; SUN: Closed
      </Text>
    </Container>
  )
}

export default Announcement